import type { QueryClient } from '@tanstack/react-query';
import { FACILITY_CONTACTS_QUERY_KEY } from '../../Organization/Facilities/queryKeys';

export const contactQueryKeys = {
  all: ['contacts'] as const,
  lists: () => [...contactQueryKeys.all, 'list'] as const,
  list: (base: string, params: Record<string, unknown>) =>
    [...contactQueryKeys.lists(), base, params] as const,
  detail: (id: string) => [...contactQueryKeys.all, 'detail', id] as const,
  links: (contactIds: readonly string[]) => [...contactQueryKeys.all, 'links', contactIds] as const,
};

/**
 * Everything a contact or facility-link write can stale: contact lists (facility
 * counts), contact details and their links, and every facility drawer's contacts
 * block (keyed `[FACILITY_CONTACTS_QUERY_KEY, facilityId]`).
 */
export const invalidateContactQueries = (queryClient: QueryClient) =>
  Promise.all([
    queryClient.invalidateQueries({ queryKey: contactQueryKeys.all }),
    queryClient.invalidateQueries({ queryKey: [FACILITY_CONTACTS_QUERY_KEY] }),
  ]);
